import React from 'react';

const ChevronUpIcon = (props) => {
  return <div {...props}>
    <img src={require('../../assets/chevron-up.svg')} />
  </div>
}

export default ChevronUpIcon
